import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { adjustDateFormatAsPerPCalendar, CrudService, CrudType, currentComponentPageBasedPermissionsSelector$, CustomDirectiveConfig, datePipeConversion, getPDropdownData, IApplicationResponse, ModulesBasedApiSuffix, MomentService, onActionSubmittedUtil, prepareDynamicTableTabsFromPermissions, prepareRequiredHttpParams, ResponseMessageTypes, RxjsService, SERVER_REQUEST_DATE_TRANSFORM, setRequiredValidator, SnackbarService, UserService } from '@app/shared';
import { DealerModuleApiSuffixModels, DEALER_COMPONENT } from '@modules/dealer';
import { loggedInUserData } from '@modules/others/auth.selectors';
import { UserLogin } from '@modules/others/models/others-module-models';
import { select, Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';

@Component({
  selector: 'app-dealer-branch-category-view',
  templateUrl: './dealer-branch-category-view.component.html',

})
export class DealerBranchCategoryViewComponent extends PrimeNgTableVariablesModel implements OnInit {


  userData: UserLogin;
  primengTableConfigPropertiesForBonus: any;
  eventSubscription: any;
  btnName: string;
  showAction: boolean;
  dealerId: string;
  dealerTypeId: string;
  referenceId: string;
  dealerBranchCategoryDetail: any;
  isSAPValidation: boolean = false;


  dateFormat = adjustDateFormatAsPerPCalendar();
  dealerBranchId = "de0eb4bf-8862-41d5-8deb-1a2e1cabb446"


  constructor(private router: Router, private activatedRoute: ActivatedRoute, private store: Store<AppState>,
    private rxjsService: RxjsService, private crudService: CrudService) {
    super();
    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.dealerId = (Object.keys(params['params']).length > 0) ? params['params']['dealerId'] : '';
      this.dealerBranchId = (Object.keys(params['params']).length > 0) ? params['params']['dealerBranchId'] : '';
      this.dealerTypeId = (Object.keys(params['params']).length > 0) ? params['params']['dealerTypeId'] : '';
      //   this.dealerBranchCategoryId = (Object.keys(params['params']).length > 0) ? params['params']['dealerBranchCategoryId'] : '';
        this.referenceId = (Object.keys(params['params']).length > 0) ? params['params']['referenceId'] : '';
    });

    this.primengTableConfigProperties = {
      tableCaption: 'View Dealer Branch Category',
      selectedTabIndex: 0,
      breadCrumbItems: [{ displayName: 'Dealer Management', relativeRouterUrl: '' }, { displayName: 'Dealer Maintenance', relativeRouterUrl: '/dealer/dealer-maintenance' }, { displayName: 'Dealer Branch Category', relativeRouterUrl: '/dealer/dealer-maintenance', queryParams: { tab: 3, id: this.dealerId, dealerTypeId: this.dealerTypeId, } }, { displayName: 'View Dealer Branch Category', relativeRouterUrl: '', }],
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'View Dealer Branch Category',
            dataKey: 'dealerId',
            enableBreadCrumb: true,
            enableAction: true,
            enableViewBtn: true,
            //  enableEdit: true,


          }

        ]
      }
    }
    this.rxjsService.setGlobalLoaderProperty(false);
    this.store.pipe(select(loggedInUserData)).subscribe((userData: UserLogin) => {
      if (!userData) return;
      this.userData = userData;
    })
    if (this.referenceId) {
      this.primengTableConfigProperties.breadCrumbItems[2].queryParams = { tab: 3, id: this.dealerId, dealerTypeId: this.dealerTypeId, referenceId: this.referenceId }
    }
  }

  ngOnInit(): void {
    this.combineLatestNgrxStoreData();
    this.getDealerDeta();
  }

  getDealerDeta() {
    let api = this.crudService.get(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_BRANCH_CATEGORY_INFO,
      null, false, prepareRequiredHttpParams({ dealerId: this.dealerId, dealerBranchId: this.dealerBranchId }));
    if (this.referenceId) {
      api = this.crudService.get(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_BRANCH_CATEGORY_INFO,
        null, false, prepareRequiredHttpParams({
          dealerId: this.dealerId, dealerBranchId: this.dealerBranchId,
          referenceId: this.referenceId, userId: this.userData?.userId
        }));
    }
    api.subscribe(data => {
      if (data.isSuccess && data.resources) {
        this.isSAPValidation = data?.resources?.isAllowEdit || false;
        if (this.referenceId) {
          this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].enableAction = this.isSAPValidation;
          this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].enableViewBtn = this.isSAPValidation;
        }
        this.onShowValue(data);
        this.rxjsService.setGlobalLoaderProperty(false);
        // this.dealerBranchCategoryDetail = data.resources;
      }
    });
  }

  onShowValue(response?: any) {
    this.dealerBranchCategoryDetail = [{
      name: 'Dealer Branch Category Details', columns: [
        { name: 'Branch Code', value: response ? response?.resources?.dealerBranchCode : '' },
        { name: 'Branch Name', value: response ? response?.resources?.branchName : '' },
        { name: 'Dealer IIP Code', value: response ? response?.resources?.dealerIIPCode : '' },
        { name: 'SAP Vendor Number(CAT:A)', value: response ? response?.resources?.sapVendorNoCatA : '' },
        { name: 'SAP Vendor Number(CAT:C)', value: response ? response?.resources?.sapVendorNoCatC : '' },
        { name: 'Attrition Threshold Rate', value: response ? response?.resources?.attritionThresholdRate : '' },
        { name: 'Bonus Start Date', value: response ? response?.resources?.bonusMultipleStartDate : '', isDate: true },
        { name: 'Commission Start Date', value: response ? response?.resources?.commissionStartDate : '', isDate: true },
        { name: 'Warehouse Name', value: response ? response?.resources?.warehouseName : '' },
        { name: 'Storage Location Name', value: response ? response?.resources?.storageLocationName : '' },
        { name: 'Tech Stack Location Number', value: response ? response?.resources?.techStockLocationNumber : '' },
        { name: 'Start Date', value: response ? response?.resources?.startDate : '', isDate: true },
        { name: 'End Date', value: response ? response?.resources?.endDate : '', isDate: true },
      ]
    }];
  }



  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(currentComponentPageBasedPermissionsSelector$)]
    ).subscribe((response) => {
      let permission = response[0][DEALER_COMPONENT.DEALER_MAINTENANCE]
      if (permission) {
        // let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigPropertiesPageLevelAccess, permission);
        // this.primengTableConfigPropertiesPageLevelAccess = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
      }
    });
  }


  onActionSubmitted(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }
  //   onCRUDRequested
  onCRUDRequested(type: CrudType | string, row?: object, unknownVar?: number | string): void {
    switch (type) {
      case CrudType.EDIT:
        this.onEditButtonClicked(row);
        break;
      default:
        break;
    }
  }

  onEditButtonClicked(row: any): void {
    if (this.referenceId) {
      this.router.navigate(['./../add-edit'], { relativeTo: this.activatedRoute, queryParams: { dealerId: this.dealerId, dealerBranchId: this.dealerBranchId, dealerTypeId: this.dealerTypeId, referenceId: this.referenceId, flag: 'edit' } });
    } else {
      this.router.navigate(['./../add-edit'], { relativeTo: this.activatedRoute, queryParams: { dealerId: this.dealerId, dealerBranchId: this.dealerBranchId, dealerTypeId: this.dealerTypeId, flag: 'edit' } });
    }
  }



  ngOnDestroy() {

    if (this.eventSubscription) {
      this.eventSubscription?.unsubscribe();
    }
  }
}
